export default __webpack_public_path__ + "static/media/mooncake-hero-zhs.a3c2d048.svg";